module.exports = __webpack_public_path__ + "media/images/sport--nordische_kombination-2ded7e293e9389860482f6a477582190.png";